import { Route } from 'vue-router/types';

export const NamedRoutes = {
  acceptedCommuneInfo: 'acceptedCommuneInfo',
  benefitsCategory: 'benefitsCategory',
  benefitsDetail: 'benefitsDetail',
  benefitsOverview: 'benefitsOverview',
  booking: 'booking',
  bookingRegistrationForm: 'bookingRegistrationForm',
  checkout: 'checkout',
  checkoutPayment: 'checkoutPayment',
  checkoutPaymentDetails: 'checkoutPaymentDetails',
  checkoutPaymentVerify: 'checkoutPaymentVerify',
  feedback: 'feedback',
  locationOptions: 'locationOptions',
  login: 'login',
  moreOverview: 'moreOverview',
  passwordReset: 'passwordReset',
  profileOverview: 'profileOverview',
  register: 'register',
  registerConfirmation: 'registerConfirmation',
  requestPasswordReset: 'requestPasswordReset',
  ticketsInfoAnonymous: 'ticketsInfoAnonymous',
  ticketsInfoBirthday: 'ticketsInfoBirthday',
  ticketsInfoDiscount: 'ticketsInfoDiscount',
  ticketsInfoPets: 'ticketsInfoPets',
  ticketsInfoSaveAccount: 'ticketsInfoSaveAccount',
  ticketsInfoResort: 'ticketsInfoResort',
  splash: 'splash',
  control: 'control',
  ticketInfoGuestType: 'ticketInfoGuestType',
  transactionDetail: 'transactionDetail',
  transactionOverview: 'transactionOverview',
  homePrinterPage: 'HomePrinterPage',
};

export const routes = [
  {
    path: '/qr/control',
    name: NamedRoutes.control,
    redirect: { name: NamedRoutes.splash },
  },
  {
    path: '/:communeId?/location-options',
    name: NamedRoutes.locationOptions,
    component: () => import('@/components/pages/LocationOptions.vue'),
  },
  {
    // should be the last route
    path: '/:communeId?/',
    name: NamedRoutes.splash,
    component: () => import('@/views/splash/Splash.vue'),
  },
];

export const communeRoutes = [
  {
    path: 'more-overview',
    name: NamedRoutes.moreOverview,
    component: () => import('@/components/pages/MoreOverview.vue'),
  },
  {
    path: 'profile-overview',
    name: NamedRoutes.profileOverview,
    component: () => import('@/components/pages/ProfileOverview.vue'),
  },
  {
    path: 'login',
    name: NamedRoutes.login,
    component: () => import('@/views/auth/LoginView.vue'),
  },
  {
    path: 'benefits-category',
    name: NamedRoutes.benefitsCategory,
    component: () => import('@/components/pages/BenefitsCategory.vue'),
  },
  {
    path: 'benefits-overview',
    name: NamedRoutes.benefitsOverview,
    component: () => import('@/components/pages/BenefitsOverview.vue'),
  },
  {
    path: 'transaction-overview',
    name: NamedRoutes.transactionOverview,
    component: () => import('@/views/taxcard/TransactionOverviewView.vue'),
  },
  {
    path: 'register',
    name: NamedRoutes.register,
    component: () => import('@/views/auth/RegisterView.vue'),
  },
  {
    path: 'request-password-reset',
    name: NamedRoutes.requestPasswordReset,
    component: () => import('@/views/auth/RequestPasswordResetView.vue'),
  },
  {
    path: 'register-confirmation',
    name: NamedRoutes.registerConfirmation,
    component: () => import('@/views/auth/RegisterConfirmationView.vue'),
  },
  {
    path: 'booking',
    name: NamedRoutes.booking,
    component: () => import('@/views/taxcard/BookingView.vue'),
  },
  {
    path: 'ticket-info-guest-type',
    name: NamedRoutes.ticketInfoGuestType,
    component: () => import('@/components/pages/TicketsInfoGuestType.vue'),
  },
  {
    path: 'accepted-commune-info',
    name: NamedRoutes.acceptedCommuneInfo,
    component: () => import('@/views/location/AcceptedCommuneInfo.vue'),
  },
  {
    path: 'feedback',
    name: NamedRoutes.feedback,
    component: () => import('@/views/feedback/FeedbackView.vue'),
  },
  {
    path: 'checkout',
    name: NamedRoutes.checkout,
    component: () => import('@/views/checkout/CheckoutView.vue'),
  },
  {
    path: 'password-reset',
    name: NamedRoutes.passwordReset,
    component: () => import('@/views/auth/PasswordResetView.vue'),
  },
  {
    path: 'tickets-info-save-account',
    name: NamedRoutes.ticketsInfoSaveAccount,
    component: () => import('@/components/pages/TicketsInfoSaveAccount.vue'),
  },
  {
    path: 'tickets-info-anonymous',
    name: NamedRoutes.ticketsInfoAnonymous,
    component: () => import('@/components/pages/TicketsInfoAnonymous.vue'),
  },
  {
    path: 'tickets-info-birthday',
    name: NamedRoutes.ticketsInfoBirthday,
    component: () => import('@/components/pages/TicketsInfoBirthday.vue'),
  },
  {
    path: 'tickets-info-pets',
    name: NamedRoutes.ticketsInfoPets,
    component: () => import('@/components/pages/TicketsInfoPets.vue'),
  },
  {
    path: 'tickets-info-resort',
    name: NamedRoutes.ticketsInfoResort,
    component: () => import('@/components/pages/TicketsInfoResort.vue'),
  },
  {
    path: 'tickets-info-discount',
    name: NamedRoutes.ticketsInfoDiscount,
    component: () => import('@/components/pages/TicketsInfoDiscount.vue'),
  },
  {
    path: 'transaction-detail',
    name: NamedRoutes.transactionDetail,
    component: () => import('@/views/taxcard/TransactionDetailView.vue'),
  },
  {
    path: 'benefits-detail',
    name: NamedRoutes.benefitsDetail,
    component: () => import('@/components/pages/BenefitsDetail.vue'),
  },
  {
    path: 'booking-registration-form',
    name: NamedRoutes.bookingRegistrationForm,
    component: () => import('@/views/taxcard/BookingRegistrationFormView.vue'),
  },
  {
    path: 'checkout-payment',
    name: NamedRoutes.checkoutPayment,
    component: () => import('@/views/checkout/CheckoutPaymentView.vue'),
  },
  {
    path: 'checkout-payment-details',
    name: NamedRoutes.checkoutPaymentDetails,
    component: () => import('@/views/checkout/CheckoutPaymentDetailsView.vue'),
  },
  {
    path: 'checkout/payment/verify',
    name: NamedRoutes.checkoutPaymentVerify,
    component: () => import('@/views/checkout/CheckoutPaymentVerifyView.vue'),
  },
  {
    path: 'home-printer',
    name: NamedRoutes.homePrinterPage,
    component: () => import('@/views/taxcard/transaction/print-overlay/HomePrinterPage.vue'),
    props: (route: Route) => ({
      taxcardIds: (route.query.taxcardIds as string[]).map((id: string) => parseInt(id, 10)),
      transactionId: parseInt(route.query.transactionId as string, 10),
      communeId: parseInt(route.query.communeId as string, 10),
    }),
  },
];

communeRoutes.forEach(r => {
  r.path = `/:communeId/${r.path}`;
});
